import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c9e167ca&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=c9e167ca&prod&scoped=true&lang=scss&"
import style1 from "./detail.vue?vue&type=style&index=1&id=c9e167ca&prod&scoped=true&lang=scss&"
import style2 from "./detail.vue?vue&type=style&index=2&id=c9e167ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e167ca",
  null
  
)

export default component.exports